<template>
  <BaseSideDetail v-model="showSubscriptionDetails">
    <template #title>
      <v-card style="width: 100%" elevation="0" class="">
        <v-card-title style="width: 100%" v-if="subscriptionDetails">
          <v-row no-gutters class="d-flex">
            <h5 class="text-uppercase primary--text">
              <BaseTooltip
                v-if="subscriptionDetails.name"
                :title="`${subscriptionModule.subscription} Name`"
                :text="subscriptionDetails.name"
              />
            </h5>
            <v-col cols="12">
              <hr class="my-2" />
            </v-col>
            <v-col cols="12">
              <v-card outlined class="mr-2 pa-0">
                <div class="d-flex" outlined>
                  <v-card-title class="grey py-1 pl-6 pr-1" style="width: 100%">
                    <span class="text-caption text-capitalize font-weight-bold">
                      No Of Days
                    </span>
                  </v-card-title>
                  <v-card-text class="py-2 text-center" style="width: 100%">
                    <span class="text-capitalize">
                      {{ subscriptionDetails.days }}
                    </span>
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12 pt-2">
              <v-card outlined class="mr-2 pa-0">
                <div class="d-flex" outlined>
                  <v-card-title class="grey py-1 pl-6 pr-1" style="width: 100%">
                    <span class="text-caption text-capitalize font-weight-bold">
                      Trial
                    </span>
                  </v-card-title>
                  <v-card-text class="py-2 text-center" style="width: 100%">
                    <span class="text-capitalize">
                      <v-icon
                        v-if="
                          subscriptionDetails && subscriptionDetails.is_trial
                        "
                        class="green--text"
                      >
                        mdi-check-circle
                      </v-icon>
                      <v-icon v-else class="red--text">mdi-close-circle</v-icon>
                    </span>
                  </v-card-text>
                </div>
              </v-card>
            </v-col>
            <v-col cols="12 pt-2">
              <v-card outlined class="mr-2 pa-0">
                <div class="d-flex" outlined>
                  <v-card-title class="grey py-1 pl-6 pr-1" style="width: 100%">
                    <span class="text-caption text-capitalize font-weight-bold">
                      Status
                    </span>
                  </v-card-title>
                  <v-card-text class="py-2 text-center" style="width: 100%">
                    <span class="text-capitalize">
                      <v-icon
                        v-if="
                          subscriptionDetails && subscriptionDetails.is_active
                        "
                        class="green--text"
                      >
                        mdi-check-circle
                      </v-icon>
                      <v-icon v-else class="red--text">mdi-close-circle</v-icon>
                    </span>
                  </v-card-text>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12">
              <hr class="my-3" />
            </v-col>
            <v-col cols="12">
              <div
                class=""
                outlined
                v-for="(value, name, index) in subscriptionDetails"
                :key="index"
              >
                <v-card
                  outlined
                  class="mr-2 pa-0 mt-2 d-flex"
                  v-if="otherDetails.indexOf(name) == -1"
                >
                  <v-card-title class="grey py-1 pl-6 pr-1" style="width: 100%">
                    <span class="text-caption text-capitalize font-weight-bold">
                      {{ name }}
                    </span>
                  </v-card-title>
                  <v-card-text class="py-2 text-center" style="width: 100%">
                    <span class="text-capitalize">
                      {{ value }}
                    </span>
                  </v-card-text>
                </v-card>
              </div>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </template>
  </BaseSideDetail>
</template>

<script>
import { bus } from "@/main.js";
import BaseSideDetail from "@/components/BaseComponents/BaseSideDetail.vue";
import BaseTooltip from "@/components/BaseComponents/BaseTooltip.vue";
import { subscriptionModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseSideDetail,
    BaseTooltip,
  },
  props: {
    value: Boolean,
    subscriptionDetailID: {
      type: Number,
    },
  },
  data() {
    return {
      subscriptionModule,
      subscriptionDetails: {},

      otherDetails: ["is_trial", "is_active", "id", "name", "days"],
    };
  },
  watch: {
    async value(val) {
      if (val) {
        if (this.subscriptionDetailID) {
          this.getSubscriptionDetails(this.subscriptionDetailID);
        }
      } else {
        this.subscriptionDetails = {};
      }
    },
    showSubscriptionDetails(val) {
      if (val) {
        this.getSubscriptionDetails(this.subscriptionDetailID);
      }
    },
    subscriptionDetailID() {
      this.getSubscriptionDetails(this.subscriptionDetailID);
    },
  },
  computed: {
    showSubscriptionDetails: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    getSubscriptionDetails(id) {
      bus.$emit("showLoader", true);
      this.$api.subscription
        .getSubscriptionObject(id)
        .then((res) => {
          this.subscriptionDetails = res.data;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style scoped lang="scss">
@mixin headerFont {
  font-family: "Roboto", sans-serif !important;
  font-size: 0.85rem;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.03125em;
  color: white;
}

.card-header-title {
  @include headerFont;
}

.card-text-border {
  border: 1px solid black;
  border-radius: 5px;
}

@media screen and (max-width: 1280px) {
  .card-header-title {
    @include headerFont;
    font-size: 0.75rem;
    line-height: 1.25rem;
    letter-spacing: 0.0333333333em;
  }
}
</style>
